import emitter from '../../mixin/emitter'

export default {
  name: 'DatePickerInput',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    uiFormItem: {
      default: '',
    },
  },

  template: `
    <flat-pickr 
      :value="currentValue"
      :config="flatpickrConfig"
      @on-change="handleChange"
      @on-close="handleClose"
    />
  `,

  props: {
    value: [String, Date],
    withTime: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    currentValue: {
      get() {
        return this.value === undefined || this.value === null ? '' : this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },

    flatpickrConfig() {
      return {
        altInput: true,
        altInputClass: `ui-input__inner width--small flatpickr-input ${this.withTime ? 'with-time' : ''}`,
        enableTime: this.withTime,
        onReady: (a, b, fp) => {
          if (fp.altInput) {
            fp.altInput.setAttribute('id', this.computedId)
          }
        },
      }
    },

    computedId() {
      if (this.id) {
        return this.id
      }

      return this.uiFormItem.computedId
    },
  },

  methods: {
    handleChange(selectedDates, dateStr) {
      this.currentValue = dateStr
      this.$emit('change', dateStr)
      this.dispatch('UiFormItem', 'ui.form.change', dateStr)
    },

    handleClose(selectedDates, dateStr) {
      this.dispatch('UiFormItem', 'ui.form.change', dateStr)
    },
  },
}
